export default __webpack_public_path__ + "static/media/Faceta_Brochure_En_190416.724fa2cb.pdf";